<template>
  <v-card flat color="transparent">
    <v-card-title v-if="all" class="pb-3 pt-0">
      <v-icon
        v-if="canAddDocComment"
        small
        color="#AAAAAA"
        title="Add document comment"
        @click="setDocComment"
        v-testid="'doc_comment_add'"
        >mdi-message-plus-outline</v-icon
      >
      <v-spacer></v-spacer>
      <v-menu
        offset-y
        :nudge-width="200"
      >
        <template v-slot:activator="{ on, attrs }">
          <span class="all-comment-header" v-bind="attrs" v-on="on"
            >Sort</span
          >
          <v-icon
            v-bind="attrs"
            v-on="on"
            small
            color="#AAAAAA"
            title="Sort options available"
            >mdi-sort</v-icon
          >
        </template>
        <v-list dense>
          <v-list-item>
            <v-list-item-icon><v-icon v-if="viewSetting.sortBy === 'date'">mdi-check</v-icon></v-list-item-icon>
            <v-list-item-title @click="doSort('date')"
              v-testid="'comment-sort-date'"
              >Most Recent</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon><v-icon v-if="viewSetting.sortBy === 'part'">mdi-check</v-icon></v-list-item-icon>
            <v-list-item-title @click="doSort('part')"
              v-testid="'comment-sort-part'"
              >Section Order</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        offset-y
        v-model="showFilterMenu"
        :close-on-content-click="false" class="filter-menu"
        :nudge-width="200" style="border-radius: 8px; border-color: #DDDDDD"
      >
        <template v-slot:activator="{ on, attrs }">
          <span class="all-comment-header" v-bind="attrs" v-on="on"
            >Filters</span
          >
          <v-icon
            v-bind="attrs" class="ml-2"
            v-on="on"
            small
            color="#AAAAAA"
            title="Filters available"
            >mdi-filter</v-icon
          >
        </template>
        <v-list dense width="400">
          <v-list-item>
            <v-list-item-icon class="mr-3" height="30">
            </v-list-item-icon>
            <v-list-item-title class="text-h6 pl-0 ml-0"
              ></v-list-item-title
            >
            <v-list-item-action-text class="ml-2" style="width: 100px"
              >{{ showResolving ? 'Unresolved' : '' }}<v-checkbox
                v-model="includeAllUnresolved"
                class="filter-checkbox"
                @click="setFilterUn"
                :title=" 
                  (includeAllUnresolved
                    ? 'Hide all'
                    : 'Show all')
                  + (showResolving ? ' unresolved' : '')
                "
                v-testid="'comment-filter-unresolved'"
              ></v-checkbox
            ></v-list-item-action-text>
            <v-list-item-action-text v-if="showResolving" class="ml-2" style="width: 100px"
              >Resolved<v-checkbox
                v-model="includeAllResolved"
                class="filter-checkbox"
                @click="setFilterRes"
                :title="
                  includeAllResolved ? 'Hide all resolved' : 'Show all resolved'
                "
                v-testid="'comment-filter-resolved'"
              ></v-checkbox
            ></v-list-item-action-text>
          </v-list-item>
          <v-subheader v-if="commentFilters.some((x) => x.type === 'creator')"
            >Comments created by:</v-subheader
          >
          <v-list-item
            v-for="(f, fi) in commentFilters.filter(
              (x) => x.type === 'creator'
            )"
            :key="'cfc' + fi"
          >
            <v-list-item-icon class="mr-3" height="30">
              <v-avatar
                :color="f.background_colour"
                size="24"
              >
                <span
                  style="font-size: 12px"
                  :style="{ color: f.text_colour }"
                >{{ f.user_initials }}</span> 
              </v-avatar>
            </v-list-item-icon>
            <v-list-item-title>{{ f.name }}</v-list-item-title>
            <v-list-item-action-text class="ml-2" style="width: 100px"
              ><v-checkbox
                v-model="f.includeUn"
                class="filter-checkbox"
                @click="doFilter"
                v-testid="'comment-filter-creator-un' + fi"
              ></v-checkbox
            ></v-list-item-action-text>
            <v-list-item-action-text v-if="showResolving" class="ml-2" style="width: 100px"
              ><v-checkbox
                v-model="f.include"
                class="filter-checkbox"
                @click="doFilter"
                v-testid="'comment-filter-creator-in' + fi"
              ></v-checkbox
            ></v-list-item-action-text>
          </v-list-item>
          <v-subheader v-if="commentFilters.some((x) => x.type === 'mention')"
            >Comments mentioning:</v-subheader
          >
          <v-list-item
            v-for="(f, fi) in commentFilters.filter(
              (x) => x.type === 'mention'
            )"
            :key="'cfm' + fi"
          >
            <v-list-item-icon class="mr-3" height="30">
              <v-avatar
                :color="f.background_colour"
                size="24"
              >
                <span
                  style="font-size: 12px"
                  :style="{ color: f.text_colour }"
                >{{ f.user_initials }}</span> 
              </v-avatar>
            </v-list-item-icon>
            <v-list-item-title>{{ f.name }}</v-list-item-title>
            <v-list-item-action-text class="ml-2" style="width: 100px"
              ><v-checkbox
                v-model="f.includeUn"
                class="filter-checkbox"
                @click="doFilter"
                v-testid="'comment-filter-mention-un' + fi"
              ></v-checkbox
            ></v-list-item-action-text>
            <v-list-item-action-text v-if="showResolving" class="ml-2" style="width: 100px"
              ><v-checkbox
                v-model="f.include"
                class="filter-checkbox"
                @click="doFilter"
                v-testid="'comment-filter-mention-in' + fi"
              ></v-checkbox
            ></v-list-item-action-text>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-title>
    <v-card-title v-else-if="!hideHeader">
      <v-icon style="padding-right: 20px">mdi-comment-outline</v-icon>
      {{ title }}
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="handler('cancel_dialogue')" small icon
                v-testid="'comment-close' + fi"
        ><v-icon>mdi-close-thick</v-icon></v-btn
      >
    </v-card-title>
    <v-divider></v-divider>
    <template v-if="!isLoading">
      <v-card-text v-if="!all">
        <Comments
          :document="document"
          :commentList="comments"
          :doc_part_id="doc_part_id"
          :dpa_tag_id="dpa_tag_id"
          :all="false"
          :showResolving="showResolving"
          :availableUsers="availableUsers"
          @saved="saved"
          @commentResolved="resolveComments"
          :testid="'document'"
        ></Comments>
      </v-card-text>
      <div v-else class="parts-container" :style="{ maxHeight: `calc(100vh - ${heightAdjustment || '210px'})` }">
        <v-card-text
          v-for="p in parts"
          :key="'p' + p.dp_id + '_' + p.dpa_tag_id"
          class="pb-0"
          :id="'part' + p.dp_id"
          @click="clickPart(p)"
          v-testid="'dp-comment-container' + p.tp_id"
          ><div
            :class="[
              'pa-2',
              'part-comment-container',
              hover_dp_id === p.dp_id ? 'highlightedCommentPart' : null,
              target_doc_part?.dp_id === p.dp_id ? 'selectedCommentPart' : null,
            ]"
            @mouseenter="highlightPartComments(p)"
            @mouseleave="highlightPartComments()"
          >
            <div class="part-comment-header">
              <div class="part-comment-header-text" :title="p.part_type" :style="p.action.headerStyle">
              {{ p.part_type }}
              {{ p.tag_value ? ": " + p.tag_value : "" }}
              </div>
              <v-icon
                v-if="p.action.add && p.showAdd"
                class="float-right ml-2"
                small title="Add new comment"
                @click="addComment(p)"
                v-testid="'dp-comment-add' + p.tp_id"
                >mdi-message-plus-outline</v-icon
              >
              <v-icon
                v-if="p.action.resolveAll"
                class="float-right ml-2"
                small
                @click="resolveAll(p)"
                title="Mark all comments as resolved"
                v-testid="'dp-comment-resolveall' + p.tp_id"
                >mdi-check-all</v-icon
              >
              <div
                class="float-right mr-2 part-filter"
                @click="showResolved(p)"
                v-if="p.action.showResolved"
                v-testid="'dp-comment-showresolved' + p.tp_id">
              <v-icon large color="#DDDDDD">mdi-toggle-switch-off</v-icon
              >Show Resolved
              </div>
              <div
                class="float-right mr-2 part-filter"
                @click="hideResolved(p)"
                v-else-if="p.action.hideResolved"
                v-testid="'dp-comment-hideresolved' + p.tp_id">
              <v-icon large >mdi-toggle-switch</v-icon
              >Hide Resolved</div>
            </div>
            <Comments
              :document="document"
              :commentList="p.comments"
              :doc_part_id="p.dp_id"
              :dpa_tag_id="p.dpa_tag_id"
              all
              :all_add="!p.showAdd"
              :showResolving="showResolving"
              :availableUsers="availableUsers"
              @saved="saved"
              @commentResolved="resolveComments"
              @cancelEdit="cancelEdit(p)"
              :testid="'doc-part' + p.tp_id"
            ></Comments>
          </div>
        </v-card-text>
      </div>
    </template>
    <ResponseHandler :serviceResponse="response"></ResponseHandler>
  </v-card>
  <!-- <Loading :isVisible="isLoading" /> -->
  <!-- </v-dialog> -->
</template>

<script>
import axios from "axios";
import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
import utils from "@/common/utils.js";
import viewUtils from "@/components/document/view/utils";
import Comments from "@/components/comments/Comments";
import ScrollTo from "vue-scrollto";
import { mapState } from "vuex";

export default {
  name: "CommentsContainer",
  components: {
    ResponseHandler,
    Comments,
  },
  props: {
    document: null,
    partType: null,
    doc_part_id: null,
    dpa_tag_id: null,
    hideHeader: Boolean,
    all: Boolean,
    target_doc_part: null,
    heightAdjustment: String,
  },
  data: function () {
    return {
      title: "",
      comments: [],
      parts: [],
      response: null,
      isLoading: true,
      utils: utils,
      dp_id: null,
      hover_dp_id: null,
      commentFilters: [],
      showFilterMenu: false,
      includeAllResolved: false,
      includeAllUnresolved: true,
      includeMention: false,
      includeMentionUn: false,
      viewSetting: { sortBy: "date" },
      availableUsers: [],
    };
  },
  updated() {},
  created() {
    if (this.document) {
      this.handler("show");
    }
  },
  computed: {
    showResolving(){
      return this.config.settings.some(
          (s) => s.setting === 'document_comments_resolve' && s.value === "true"
      );
    },  
    defaultSortOrder(){
      return this.config.settings.find(
          (s) => s.setting === 'document_comments_sort_order')?.value;
    },
    ...mapState({
      config: (state) => state.settings.config,
    }), 
  },
  watch: {
    doc_part_id(newval) {
      if (newval !== this.dp_id) this.handler("show");
    },
    dpa_tag_id() {
      this.handler("show");
    },
    target_doc_part(newval) {
      this.setDocPart(newval);
    },   
  },
  methods: {
    findPart(key, action) {
      const index = this.parts.findIndex((x) => x.dp_id === key.dp_id && x.dpa_tag_id === key.dpa_tag_id);
      if (action === "delete") {
        if (index >= 0) this.parts.splice(index,1);
        return;
      }
      return {
        index: index,
        item: index >= 0 ? this.parts[index] : null,
      }; 
    },
    setDocPart(newval) {
      if (this.all && newval) {
        if (newval.deleted) {
          this.findPart(newval, "delete");
          return;
        }
        this.hover_dp_id = newval.dp_id;
        const part = this.findPart(newval).item;
        if (!part) {
          const p = this.decoratePart(newval);
          p.showAdd = false; // so that new comment box appears
          this.parts.unshift(p);
          this.$nextTick(() => this.scrollToPart(newval));
        } else {
          // also scroll to dp comment section and show new comment box
          part.showAdd = false; // so that new comment box appears
          this.scrollToPart(newval);
        }
      }
    },
    setDocComment() {
      let nullPart = this.parts.find((x) => x.dp_id === null);
      if (!nullPart) {
        this.parts.unshift(this.decoratePart());
      } else {
        nullPart.showAdd = false;
      }
    },
    doSort(setting) {
      if (setting) {
        const doSave = this.viewSetting.sortBy !== setting;
        this.viewSetting.sortBy = setting;
        if (doSave) this.saveViewSetting();
      }
      if (this.viewSetting.sortBy === "date")
        this.parts.sort((a,b) => a.comments[0].created_date_raw < b.comments[0].created_date_raw ? 1 : a.comments[0].created_date_raw > b.comments[0].created_date_raw ? -1 : 0);
      else
        this.parts.sort((a,b) => a.part_type_sequence > b.part_type_sequence ? 1 : a.part_type_sequence < b.part_type_sequence ? -1 : 0);
    },
    doFilter() {
      let creatorsRes = this.commentFilters
        .filter((x) => x.type === "creator" && x.include)
        .map((x) => x.name);
      let creatorsUnRes = this.commentFilters
        .filter((x) => x.type === "creator" && x.includeUn)
        .map((x) => x.name);
      const hasMentions = this.commentFilters.some((x) => x.type === "mention");
      let mentionsRes = hasMentions
        ? this.commentFilters
            .filter((x) => x.type === "mention" && x.include)
            .map((x) => x.name)
        : null;
      let mentionsUnRes = hasMentions
        ? this.commentFilters
            .filter((x) => x.type === "mention" && x.includeUn)
            .map((x) => x.name)
        : null;
      const setVisible = (comments) => {
        comments.forEach((c) => {
          c.visible = this.showResolving && c.resolved
            ? creatorsRes.some((x) => x === c.user_name) &&
              (!hasMentions ||
                c.mentions.some((x) => mentionsRes.some((m) => m === x)))
            : creatorsUnRes.some((x) => x === c.user_name) &&
              (!hasMentions ||
                c.mentions.some((x) => mentionsUnRes.some((m) => m === x)));
          if (c.visible && c.replies) setVisible(c.replies);
        });
      };
      this.parts.forEach((p) => setVisible(p.comments));
    },
    setFilterUn() {
      this.commentFilters.forEach(
        (x) => (x.includeUn = this.includeAllUnresolved)
      );
      this.doFilter();
    },
    setFilterRes() {
      this.commentFilters.forEach((x) => (x.include = this.includeAllResolved));
      this.doFilter();
    },
    decorateComments(data, dp_id) {
      data.forEach((x) => {
        x.visible = !x.resolved || !this.showResolving;
        x.editAllowed = this.setCanAdd({ dp_id: dp_id }) && x.user_id === this.$loginState.user.user_id;
        x.editInProgress = false;
        x.editIsDirty = false;
        x.reply = {
          show: false,
          isDirty: false,
          text: "",
          document_comment_id_parent: x.document_comment_id,
          user_id_parent: x.user_id,
          dp_id: x.dp_id,
          dpa_tag_id: x.dpa_tag_id,
          setFocusTrigger: 0,
        };
      });
      let stack = (parent) => {
        let nodes = data.filter((x) => x.document_comment_id_parent === parent);
        nodes.forEach((n) => {
          n.replies = stack(n.document_comment_id);
          if (n.replies.length > 0) n.editAllowed = false;
        });
        return nodes;
      };
      let newVal = stack(null);
      return newVal;
    },
    saved(data) {
      let processed = this.decorateComments(data.comments, data.dp_id);
      this.comments.splice(0, this.comments.length, ...processed);
      if (this.all && this.parts) {
        const part = this.findPart(data);
        if (part.item) {
          part.item.comments.splice(0, part.item.comments.length, ...processed);
          part.item.showAdd = true;
          if (!part.item.comments.length) {
            this.parts.splice(part.index, 1);
          }
        }else {
          this.parts.unshift(this.decoratePart(data, 0, processed));
        }
      }
      //   if (this.part) this.part.hasComments = data.comments.length > 0;
      this.$emit("saved", data);
    },
    docPartCommentAction() {
      return this.document.state ? this.document.state.docPartCommentAction : this.document.commentActions?.find(x => x.isComment);
    },
    docCommentAction() {
      return this.document.state ? this.document.state.docCommentAction : this.document.commentActions?.find(x => x.isDocumentComment);
    },
    setCanAdd(part) {
      return part.dp_id && !!this.docPartCommentAction()
    },
    canAddDocComment() {
      return !!this.docCommentAction();
    },
    async handler(action) {
      let request;

      switch (action) {
        case "show":
          await this.getViewSetting();
          this.title = `${this.partType || "Document"} Comments`;
          this.handler("cancel_new");
          this.isLoading = true;
          this.dp_id = this.doc_part_id;

          if (this.all)
            request = `workflow/getDocComments/${this.document.doc_id}`;
          else if (this.dpa_tag_id && this.doc_part_id)
            request = `workflow/getDocPartTagComments/${this.document.doc_id}/${this.doc_part_id}/${this.dpa_tag_id}`;
          else if (this.doc_part_id)
            request = `workflow/getDocPartComments/${this.document.doc_id}/${this.doc_part_id}`;
          else request = `workflow/getDocLevelComments/${this.document.doc_id}`;

          if (!request) return;

          await axios
            .get(request)
            .then((resp) => {
              if (resp.data.Status === "OK") {
                if (this.all) {
                  this.parts = resp.data.Data.parts.map((p) => {
                    let dp = this.document.templateParts ? this.document.templateParts.find(x => x.data.some(d => d.dp_id === p.dp_id)) : null;
                    let dpSeq = dp ? dp.data.find(d => d.dp_id === p.dp_id).part_type_sequence : null;
                    if (! dp && this.document.doc_view_config) {
                      let sections = viewUtils.getFlatSections(this.document.doc_view_config.sections);
                      let section = sections.length ? sections[0] : null;
                      if (section) {
                        section.part_data.forEach((pd, pdi) => {
                          if (!dpSeq) {
                            let dpIndex = pd.parts.findIndex(x => x.dp_id === p.dp_id);
                            if (dpIndex >= 0) {
                              dpSeq = (pdi * 1000000) + (dpIndex * 10000);
                            }
                          }
                        })
                      }
                    }
                    return this.decoratePart(p, dpSeq);
                  });
                  this.commentFilters = resp.data.Data.mentions.map((n) => {
                    return {
                      type: "mention",
                      name: n.name,
                      user_initials: n.user_initials,
                      text_colour: n.text_colour,
                      background_colour: n.background_colour,
                      include: false,
                      includeUn: true,
                    };
                  });
                  resp.data.Data.creators.forEach((n) => {
                    this.commentFilters.push({
                      type: "creator",
                      name: n.name,
                      user_initials: n.user_initials,
                      text_colour: n.text_colour,
                      background_colour: n.background_colour,
                      include: false,
                      includeUn: true,
                    });
                  });
                  this.setDocPart(this.target_doc_part);
                  this.doSort();
                } else {
                  let processed = this.decorateComments(resp.data.Data, this.doc_part_id);
                  this.comments.splice(0, this.comments.length, ...processed);
                }
              }
              this.isLoading = false;
            })
            .catch((err) => {
              if (err.response && err.response.status === 401) {
                this.$emit("sessionExpired", err);
              } else {
                console.log(err);
                this.response = err.response
                  ? err.response.data
                  : { message: "Unexpected Error" };
              }
              this.isLoading = false;
            });
          if (!!this.docPartCommentAction() || !!this.docCommentAction()) {            
            let request = {
              doc_id: this.document.doc_id,
            };
            await axios
              .post("workflow/getDocumentCommentUsers/", request)
              .then((resp) => {
                if (resp.data.Status === "OK") {
                  this.availableUsers = resp.data.Data.items;
                }
                this.isLoading = false;
              })
              .catch((err) => {
                if (err.response && err.response.status === 401) {
                  this.$emit("sessionExpired", err);
                } else {
                  console.log(err);
                  this.response = err.response
                    ? err.response.data
                    : { message: "Unexpected Error" };
                }
                this.removeComment.show = false;
                this.isLoading = false;
              });
          }
          break;
        case "cancel_dialogue":
          this.$emit("closed");
          break;
      }
    },
    decoratePart(source, dpSeq, comments) {
      let comms = comments || source?.comments;
      let seq = dpSeq !== undefined ? dpSeq : source?.part_type_sequence;
      let part = {
        dp_id: source?.dp_id || null,
        part_type: source?.part_type || "Document Comments",
        dpa_tag_id: source?.dpa_tag_id || null,
        tag_value: source?.tag_value || null,
        part_type_sequence: seq || 0,
        showAdd: !!source,
        canAdd: source ? this.setCanAdd(source) : this.canAddDocComment(),
        comments: comms ? this.decorateComments(comms, source.dp_id) : [],
      };
      this.setPartActions(part);
      return part;
    },
    setPartActions(part) {
      if (!part.action) part.action = {};
      part.action.add = part.canAdd && part.showAdd;
      part.action.resolveAll = this.showResolving && part.canAdd && part.comments.some((c) => c.resolved === 0);
      part.action.showResolved = this.showResolving && part.comments.some((c) => !c.visible && c.resolved === 1);
      part.action.hideResolved = !part.action.showResolved && this.showResolving && part.comments.some((c) => c.visible && c.resolved === 1);
      let actionwidth = 
        (part.action.add ? 24 : 0) +
        (part.action.resolveAll ? 24 : 0) +
        (part.action.showResolved ? 150 : 0) +
        (part.action.hideResolved ? 150 : 0);
      part.action.headerStyle = { maxWidth: `calc(100% - ${actionwidth}px)` };
    },
    hideResolved(part) {      
      part.comments
        .filter((c) => c.resolved)
        .forEach((c) => (c.visible = false));
      this.setPartActions(part);
    },
    showResolved(part) {  
      this.recurseComments(part.comments, true);
      this.setPartActions(part);
    },
    recurseComments(comments, visible) {
      comments
        .forEach((c) => {
          c.visible = visible;
          if (c.replies?.length) this.recurseComments(c.replies, visible);
        });
    },
    addComment(part) {   
      part.showAdd = false;
      this.setPartActions(part);
    },
    highlightPartComments(part) {
      if (this.all && part) {
        this.hover_dp_id = part.dp_id;
        this.$emit("mouseenter", part);
      } else if (this.hover_dp_id !== this.target_doc_part?.dp_id) {
        this.hover_dp_id = null;
        if (this.all) this.$emit("mouseleave");
      }
    },
    clickPart(part) {
      if (part.dp_id !== this.target_doc_part?.dp_id)
        this.$emit("commentclick", part);
    },
    scrollToPart(part) {
      if (!part.dp_id) return;
      let options = {
        container: ".parts-container", //this.$refs.doccontainer, //"#container",
        easing: "ease-in",
        offset: -150,
        force: true,
        cancelable: true,
        x: false,
        y: true,
      };
      ScrollTo.scrollTo("#part" + part.dp_id, 500, options);
    },
    resolveAll(part) {
      this.resolveComments(
        {
          doc_id: this.document.doc_id,
          document_comment_id: null,
          dp_id: part.dp_id,
          dpa_tag_id: part.dpa_tag_id,
          resolved: 1,
        },
        part
      );
    },
    resolveComments(request, part) {
      if (!this.document) return;
      this.isLoading = true;
      axios
        .post("document/CommentResolved/", request)
        .then((resp) => {
          if (resp.data.Status === "OK") {
            if (part && request.resolved === 1) {
              part.comments
                .filter((c) => c.resolved !== 1)
                .forEach((c) => (c.resolved = 1));
            }
            if (part) this.setPartActions(part);
            this.$emit("commentResolved", request);
          } else {
            alert(resp.data.Message);
          }
          this.isLoading = false;
          this.response = resp.data;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
    async cancelEdit(part) {
      if (!part.comments.length) {
        this.findPart(part,"delete");
        this.$emit("resetCommentPart");
      } else {
        part.showAdd = true;
        this.setPartActions(part);
      }
    },
    async getViewSetting() {
      let resp = await this.$loginState.getUserViewSetting(this.$options._componentTag);
      if (resp) {
        this.viewSetting = resp;
      } else {
        this.viewSetting.sortBy = this.defaultSortOrder ?? "date";
      }
    },
    async saveViewSetting() {
      let resp = await this.$loginState.saveUserViewSetting(this.$options._componentTag, this.viewSetting);
    },
  },
};
</script>
<style scoped>
.parts-container {
  overflow-y: auto;
  overflow-x: hidden;
}
.part-comment-container {
  background-color: #f7f9fb;
  border-radius: 16px;
}
.part-comment-header {
  padding: 8px;
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0%;
  line-height: 100%;
  color: #888888;
}
.part-comment-header-text {
  max-width: 50%;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.part-filter {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0%;
  line-height: 100%;
  color: #888888;
  margin-top: -8px;
  cursor: pointer;
}
.highlightedCommentPart {
  background-color: #e6f1fb;
  border-radius: 16px;
}
.selectedCommentPart {
  background-color: #d5e8fc;
  border: solid 1px rgb(211, 210, 210);
  border-radius: 16px;
}
.all-comment-header {
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0%;
  line-height: 100%;
  color: #888888;
  margin-left: 5px;
  margin-right: 5px;
}
.filter-checkbox {
  padding-left: calc(50% - 12px);
}
</style>
